import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { DocumentaryResourceVM } from "@shared-kernel/domain/types/documentary-resource";
import { documentaryResourcesRetrieve } from "./documentary-resources-retrieve";

const initialState: RetrievalState<DocumentaryResourceVM[]> = { fetching: "idle", data: [] };

export const documentaryResourcesRetrieveReducer = createReducer<RetrievalState<DocumentaryResourceVM[]>>(initialState, builder => {
  builder.addCase(documentaryResourcesRetrieve.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(documentaryResourcesRetrieve.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(documentaryResourcesRetrieve.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
